<div class="field-checkbox mt-2 ml-3">
    <p-inputSwitch [inputId]="'c' + pergunta.id" [(ngModel)]="pergunta.resposta" [disabled]="!habilitado"
        (ngModelChange)="respostaAlterada()"></p-inputSwitch>
    <label [attr.for]="'c' + pergunta.id">{{pergunta.detalhesTitulo}}</label>
</div>